import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 1.25C15.6086 1.25 19.75 5.39137 19.75 10.5C19.75 15.6086 15.6086 19.75 10.5 19.75C5.39137 19.75 1.25 15.6086 1.25 10.5C1.25 5.39137 5.39137 1.25 10.5 1.25ZM9.51172 4.5498V6.00293C8.20009 6.34291 7.2501 7.35655 7.25 8.5498C7.25 10.4031 8.95633 10.843 10.3262 11.1963C11.7473 11.5495 12.4188 11.8167 12.4189 12.5498C12.4189 13.2698 11.5337 13.8838 10.4805 13.8838C9.42737 13.8837 8.54199 13.2697 8.54199 12.5498H7.25C7.25 13.7431 8.20003 14.7567 9.51172 15.0967V16.5498H11.4502V15.0967C12.7618 14.7566 13.7119 13.7431 13.7119 12.5498C13.7118 10.6966 12.0055 10.2566 10.6357 9.90332C9.21427 9.55 8.54199 9.28312 8.54199 8.5498C8.54214 7.82995 9.42746 7.21691 10.4805 7.2168C11.5336 7.2168 12.4188 7.82988 12.4189 8.5498H13.7119C13.7118 7.35658 12.7618 6.34294 11.4502 6.00293V4.5498H9.51172Z"
      fill="#222A5C"
    />
  </svg>,
  "DonationHistoryFilled"
);
